
<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="
        vx-col
        flex
        items-center
        justify-center
        flex-col
        sm:w-1/2
        md:w-3/5
        lg:w-3/4
        xl:w-1/2
        mx-auto
        text-center
      "
    >
      <img
        src="@/assets/images/pages/404.png"
        alt="graphic-404"
        class="mx-auto mb-4 max-w-full"
      />
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-text-inverse">
        This is not for you
      </h1>
      <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-text-inverse">
        You do not have access to Admin LIFE. Please contact REKOM IT.
      </p>
      <vs-button @click="logout" size="large" to="/">Logout</vs-button>
    </div>
  </div>
</template>

<script>
//import { msalMixin } from 'vue-msal';

export default {
  //mixins: [msalMixin],
  data() {
    return {};
  },
  methods: {
    logout() {
      this.$AuthService.logout();
    },
  },
};
</script>
